export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13999.216ea34a.jpg";